export default __webpack_public_path__ + "static/media/sebore_logo_two.74908e82.png";